import { render, staticRenderFns } from "./EventInfoCell.vue?vue&type=template&id=13580f81&scoped=true&"
import script from "./EventInfoCell.vue?vue&type=script&lang=js&"
export * from "./EventInfoCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13580f81",
  null
  
)

export default component.exports